// extracted by mini-css-extract-plugin
export var searchHeader = "_85-0";
export var searchHeaderDark = "_85-1";